import { Component, ChangeDetectionStrategy } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';

@Component({
    selector: 'app-freeze-overlay',
    standalone: true,
    imports: [MatIconModule, MatButtonModule],
    changeDetection: ChangeDetectionStrategy.OnPush,
    template: `
    <div class="freeze-root">
      <div class="card">
        <div class="icon-wrap">
          <span class="material-icons icon">wifi_off</span>
          <div class="ring" aria-hidden="true"></div>
        </div>

        <div class="text">
          <div class="title">Geen verbinding — applicatie gepauzeerd</div>
          <div class="subtitle">We hervatten je acties zodra de verbinding terug is.</div>
        </div>

        <div class="chip">Offline</div>
      </div>
    </div>
  `,
    styles: [`
    :host, .freeze-root {
      position: fixed; inset: 0;
      display: grid; place-items: center;
      pointer-events: none;
    }

    .freeze-root {
      padding: 16px;
    }

    .card {
      width: min(420px, 92vw);
      border-radius: 16px;
      padding: 18px;
      box-shadow: 0 10px 30px rgba(0,0,0,.25);
      background: rgba(20,20,20,.85);
      color: #fff;
      border: 1px solid rgba(255,255,255,.08);
      display: flex; align-items: center; gap: 16px;
      pointer-events: auto;
    }

    .icon-wrap { position: relative; width: 40px; height: 40px; }
    .icon {
      font-size: 36px; width: 36px; height: 36px; line-height: 36px;
      display: block; opacity: .95; position: relative; z-index: 1;
    }
    .ring {
      position: absolute; left: -6px; top: -6px; right: -6px; bottom: -6px;
      border-radius: 999px;
      border: 3px solid rgba(255,255,255,.18);
      border-top-color: rgba(255,255,255,.8);
      animation: atp-spin 1s linear infinite;
    }

    .text { display: grid; gap: 4px; flex: 1 1 auto; }
    .title { font-weight: 600; font-size: 15px; }
    .subtitle { opacity: .85; font-size: 13px; }

    .chip {
      margin-left: auto; padding: 6px 10px; font-size: 12px; line-height: 1;
      border-radius: 999px; background: rgba(255,255,255,.1); border: 1px solid rgba(255,255,255,.14);
      white-space: nowrap;
    }

    @keyframes atp-spin { to { transform: rotate(360deg); } }
    @media (prefers-reduced-motion: reduce) {
      .ring { animation: none; }
    }
  `]
})
export class FreezeOverlayComponent { }
